// extracted by mini-css-extract-plugin
module.exports = {"container":"HtmlBlock__container___3u8HC"};